import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { addComment, deleteComment, editComment,} from "../../../apis/apiService";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useFetchGetallProjetsCommentsQuery,
  useFetchNotificationListQuery,
  useFetchProjectActivityQuery,
  useFetchViewProjectsByIdQuery,
} from "../../../slice/logdetailSlice";
import { Avatar, Tooltip } from "@mui/material";
import Swal from "sweetalert2";
import { useTheme } from "../../../ThemeContext";
import RichText from "../../common/RichText";

const Comments = ({ projectDetail }) => {
  const { isDarkMode } = useTheme();
  // const project = projectDetail[0];
  // //console.log()(projectDetail.project_id, "projecttt");
  const [commentText, setCommentText] = useState("");
  const [comments, setComments] = useState([]);
  const [comment_detail, setCmment_detail] = useState([]);
  const [isEditing, setIsEditing] = useState(null);
  const [hoveredButton, setHoveredButton] = useState(null);
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { refetch: project_activity } = useFetchProjectActivityQuery(id);
  const { refetch: notification_refetch } = useFetchNotificationListQuery();
  const { refetch: project_detail, } = useFetchViewProjectsByIdQuery(id);
  const { data: get_all_commets, refetch } =
    useFetchGetallProjetsCommentsQuery(id);
  // //console.log()("getAllProjetsComments  in project page:", get_all_commets);

  const projectId = projectDetail.project_id;
  useEffect(() => {
    if (get_all_commets) {
      const transformedComments = Array.isArray(get_all_commets)
        ? get_all_commets.map((comment) => ({
            id: comment.comment_id,
            text: comment.comments || "", // Ensure text is not undefined
            addedAt: comment.added_at,
            addedBy: comment.added_by,
            added_name: comment.added_name,
            profile: comment.image_url,
            attachment: comment.attachment || null,
          }))
        : [];

      setComments(transformedComments);
      setCmment_detail(transformedComments);
    }
  }, [get_all_commets]);

  useEffect(() => {
    const storedComments = JSON.parse(localStorage.getItem("comments")) || [];
    setComments(storedComments);
  }, []);

  // Save comments to local storage
  const saveToLocalStorage = (newComments) => {
    localStorage.setItem("comments", JSON.stringify(newComments));
  };

  // Handle comment submission(add)
  const handleAddComment = async () => {
    if (!commentText.replace(/<(.|\n)*?>/g, "").trim()) {
      toast.warn("Please enter a comment.");
      return;
    }

    setLoading(true);
    try {
      const response = await addComment(
        "projects",
        projectDetail?.project_id,
        commentText,
        attachmentFile
      );

      if (response) {
        toast.success(response.message || "Comment added successfully!");
        refetch();
        project_activity();
        project_detail();
        // Reset input and trigger re-render
        setCommentText(""); // Reset state
        setAttachmentFile(null);

        // Force Quill editor to clear
        document.querySelector(".ql-editor").innerHTML = ""; // 🛠 Fix: Force clear Quill
      } 
      else {
        toast.error(
          response.message || "Failed to add comment. Please try again."
        );
      }
    } 
    catch (error) {
      toast.error("Failed to add comment. Please try again.");
    } 
    finally {
      setLoading(false);
    }
  };

  const handleDeleteComment = async (id, commentText) => {
    const cleanText = commentText.replace(/<[^>]*>/g, "").trim();
    const truncatedText = cleanText.length > 60 ? cleanText.substring(0, 60) + "..." : cleanText;

    Swal.fire({
      title: "Confirm Deletion",
      html: `Are you sure you want to delete this comment<br/>"<strong>${truncatedText}</strong>"?`,                        
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "Cancel",
      showCloseButton: true,
      customClass: {
        popup: "custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);

      // Call the deleteComment service
          const response = await deleteComment("projects", id);

      // Check if the API response indicates success
          if (response?.status) {
        // Remove the comment from the local state
            const updatedComments = comments.filter((comment) => comment.id !== id);
            setComments(updatedComments);
        // saveToLocalStorage(updatedComments);
            project_activity();
            project_detail();
        // Show success message
            refetch();
            toast.success(response.message || "Comment deleted successfully!");
          } else {
        // Show an error message if the status is false
            toast.error(
              response.message || "Failed to delete comment. Please try again."
            );
          }
        } 
        catch (error) {
      // Handle any errors
          console.error("Error deleting comment:", error);
          toast.error("Failed to delete comment. Please try again.");
        } 
         {
      // Hide loading indicator (optional)
          setLoading(false);
        }
      }
    });
  };

  const handleEditComment = (id) => {
    const comment = comments.find((comment) => comment.id === id);

    if (!comment) {
      console.error("Comment not found for ID:", id);
      return;
    }

    setCommentText(comment.text);
    setIsEditing(id);
  };

  // Save edited comment
  const handleSaveEdit = async () => {
    if (!commentText.replace(/<(.|\n)*?>/g, "").trim()) {
    toast.warn("No comment values to update, please enter comment.");
      return;
    }

    setLoading(true);
    try {
      // Call the API to save the edited comment
      const response = await editComment(
        "projects",
        isEditing, // The ID of the comment being edited
        commentText, // Updated text
        attachmentFile // Optional attachment
      );

      if (response?.status) {
        toast.success(response.message || "Comment updated successfully!");

        // Update the specific comment in the state
        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment.id === isEditing
              ? {
                  ...comment,
                  text: commentText, // Updated text
                  attachment: attachmentFile || comment.attachment, // Keep old attachment if no new one
                  addedAt: new Date().toISOString(), // Optional: Update timestamp
                }
              : comment
          )
        );

        // Clear editing state
        setCommentText("");
        refetch();
        project_activity();
        notification_refetch();
        setAttachmentFile(null);
        setIsEditing(null);
      } else {
        toast.error(
          response.message || "Failed to update comment. Please try again."
        );
      }
    } 
    catch (error) {
      toast.error("Failed to update comment. Please try again.");
    } 
    finally {
      setLoading(false);
    }
  };

  // //console.log()("commments:", comment_detail);

  return (
    <div className="py-3">
      <div
        style={{ border: "1px solid #ccc", padding: "10px" }}
        className="rounded"
      >
        <ReactQuill
          value={commentText}
          onChange={setCommentText}
          placeholder="Write a comment..."
        />

        <div className="text-end py-3">
          <button
            onClick={isEditing ? handleSaveEdit : handleAddComment}
            className="add_btn me-3 "
            disabled={loading}
          >
            {isEditing ? "Update Comment" : "Add Comment"}
          </button>

          <button
            onClick={() => {
              setCommentText("");
              setIsEditing(null);
            }}
            className="cancel_btn"
          >
            Cancel
          </button>
        </div>
      </div>

      <div style={{ borderTop: isDarkMode ? "2px dashed rgba(255, 255, 255, 0.2)" : "2px dashed " }} className="my-4"></div>
      <div className="comments-feed" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {comment_detail?.map((comment) => (
          <div
            key={comment.id}
                        style={{
              backgroundColor: isDarkMode ? "transparent" : "#ffffff",
              border: isDarkMode ? "1px solid rgba(255, 255, 255, 0.15)" : "1px solid #e2e8f0",
              borderRadius: "7px",
              padding: "16px",
              boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.03)",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
            }}
            className="comment-card"
          >
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center gap-3">
                    <Avatar
                      src={comment.profile}
                      alt={comment.added_name?.[0]}
                  style={{ width: "40px", height: "40px", border: isDarkMode ? "2px solid rgba(255, 255, 255, 0.15)" : "2px solid #e2e8f0" }}
                    />
                <div>
                  <div style={{ fontWeight: "600", fontSize: "14px", color: isDarkMode ? "#ffffff" : "#0f172a" }}>
                    {comment.added_name}
                  </div>

                  <div style={{ fontSize: "11px", color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "#64748b" }}>
                  {new Date(comment.addedAt).toLocaleString()}
                  </div>
                </div>

              </div>
                  <div style={{ display: "inline-flex", backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "#f1f5f9", borderRadius: "20px", padding: "2px", gap: "2px" }}>
                    <Tooltip title="Edit">
                      <button
                        onClick={() => handleEditComment(comment.id)}
                        className="R_btn text-rgba-blue"
                        style={{
                          padding: "6px 8px",
                          borderRadius: "20px",
                          backgroundColor: hoveredButton === `edit-${comment.id}` ? (isDarkMode ? "rgba(255, 255, 255, 0.15)" : "#dbeafe") : "transparent",
                          transition: "background-color 0.2s ease-in-out",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onMouseEnter={() => setHoveredButton(`edit-${comment.id}`)}
                        onMouseLeave={() => setHoveredButton(null)}
                      >
                        <FaRegEdit size={18} />
                      </button>
                    </Tooltip>

                    <Tooltip title="Delete">
                      <button
                        onClick={() => handleDeleteComment(comment.id, comment.text)}
                        className="R_btn tex-tgba-red"
                        style={{
                          padding: "6px 8px",
                          borderRadius: "20px",
                          backgroundColor: hoveredButton === `delete-${comment.id}` ? (isDarkMode ? "rgba(255, 255, 255, 0.15)" : "#fee2e2") : "transparent",
                          transition: "background-color 0.2s ease-in-out",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onMouseEnter={() => setHoveredButton(`delete-${comment.id}`)}
                        onMouseLeave={() => setHoveredButton(null)}
                      >
                        <RiDeleteBin5Line size={18} />
                      </button>
                    </Tooltip>
                  </div>
            </div>

            <RichText
              style={{
                marginLeft: "52px",
                fontSize: "14px",
                lineHeight: "1.6",
                color: isDarkMode ? "#f1f5f9" : "#334155",
              }}
              html={comment.text}
            />
            
            {comment.attachment && (
              <div style={{ marginLeft: "52px", marginTop: "8px" }}>
                <a
                  href={comment.attachment}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    fontSize: "12px",
                    color: isDarkMode ? "#38bdf8" : "#0284c7",
                    textDecoration: "none",
                    backgroundColor: isDarkMode ? "rgba(56, 189, 248, 0.1)" : "#f0f9ff",
                    padding: "4px 10px",
                    borderRadius: "7px",
                    border: isDarkMode ? "1px solid rgba(56, 189, 248, 0.2)" : "1px solid #bae6fd",
                    fontWeight: "500",
                    transition: isDarkMode ? "background-color 0.2s, color 0.2s, border-color 0.2s" : "background-color 0.2s",
                  }}
                  onMouseEnter={(e) => { e.target.style.backgroundColor = isDarkMode ? "rgba(56, 189, 248, 0.2)" : "#e0f2fe"; }}
                  onMouseLeave={(e) => { e.target.style.backgroundColor = isDarkMode ? "rgba(56, 189, 248, 0.1)" : "#f0f9ff"; }}
                >
                  📎 Attachment
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Comments;
